<template>
  <div class="footer wrap">
    <div class="header-footer-container container">
      <div class="row link-cols" :class="horizol">
        <ul>
          <li v-if="horizol">
            <router-link to="/">Home</router-link>
          </li>
          <li>
            <router-link to="/privacy-policy">Privacy</router-link>
          </li>
          <li>
            <router-link to="/terms-of-service">Terms</router-link>
          </li>
          <li>
            <router-link to="/Support">Support</router-link>
          </li>
        </ul>
      </div>
      <div class="row thoughtful-world">
        <h4>💖Tech makes the life better.</h4>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["horizol"]
};
</script>

<style scoped>
ul {
  display: flex;
  flex-direction: column;
}
.footer {
  border-top: none;
}
ul.horizol {
  margin: 24px;
}

ul li {
  font-size: 16px;
  margin: 12px;
  text-align: right;
}
</style>
